import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
/**
 * @customElement anmeldung-page-declaration
 */
@customElement('anmeldung-page-declaration')
export class AnmeldungPageDeclaration extends ChemistryLitElement {
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          height: '100%',
          overflow: 'auto',
        },
      },
    ];
  }

  override render() {
    return html`<cr-section space="md" ${css({ marginTop: this.spacing.xl, marginBottom: this.spacing.xl })}>
      <chancen-component-anmeldung-consent .print=${false}></chancen-component-anmeldung-consent>
      <!-- <anmeldung-component-formfield-consent-eval></anmeldung-component-formfield-consent-eval> -->
      <!-- <anmeldung-component-formfield-consent-picture></anmeldung-component-formfield-consent-picture> -->
    </cr-section>`;
  }
}
